class Dom {

    /**
     * Wrap inner
     * @param parent node
     * @param wrapper tipo di elemento da usare come wrapper. Es: "div"
     * @param attribute name
     * @param attributevalue text
     * 
     * wrapInner('body', 'div', 'class', 'my-class');
     */
    wrapInner(parent, wrapper, attribute, attributevalue) {
        if (typeof wrapper === "string") {
            wrapper = document.createElement(wrapper);
        }
        var div = parent.appendChild(wrapper).setAttribute(attribute, attributevalue);

        while (parent.firstChild !== wrapper) {
            wrapper.appendChild(parent.firstChild);
        }
    }
}

// export
export default new Dom();